export default __webpack_public_path__ + "static/media/Restarents.12db5a31.svg";